import {
  getChildren
} from '@/api/index'
import {
  getShopGrade
} from '@/api/admin/marketing/shop'
import {
  getStore
} from "@/util/store.js";
import {
  getUserRules,
  getTxType
} from '@/api/sellerAdmin/index'
import {
  getAdminUserRules
} from '@/api/admin/index'
import {
  routerAll
} from '@/router/new-seller/index.js' // 商家
import {
  adminRouterAll
} from '@/router/new-admin/index.js'
import _ from 'lodash'
const app = {
  state: {
    goodsType: [],
    cityOption: [],
    packageList: [],
    selectedKeys: [],
    firstRoute: false,
    menuList: [],
    productType: 0,
    txStatus: true,

  },
  mutations: {
    updateGoodsType(state, value) {
      state.goodsType = value
    },
    updateCityOption(state, value) {
      state.cityOption = value
    },
    updatePackageList(state, value) {
      state.packageList = value
    },
    updateSelectedKeys(state, value) {
      state.selectedKeys = value
    },
    updateFirstRoute(state, value) {
      state.firstRoute = value
    },
    updateMenu(state, value) {
      state.menuList = value
    },
    updateProductType(state, value) {
      state.productType = value
    },
    updateTxStatus(state, value) {
      state.txStatus = value
    },
  },
  actions: {
    setGoodsType(context, data) {
      context.commit('updateGoodsType', data.value)
    },
    setSelectedKeys(context, data) {
      context.commit('updateSelectedKeys', data)
    },
    setCityOption(context) {
      getChildren(0).then(res => {
        let data = res.map(item => {
          return {
            value: item.Id,
            label: item.Name,
            isLeaf: item.bo,
            level: item.Level
          }
        })
        context.commit('updateCityOption', data)
      })
    },
    setPackageList(context) {
      getShopGrade().then(res => {
        let data = res.rows.map(item => {
          return {
            value: item.Id,
            label: item.Name,
          }
        })
        context.commit('updatePackageList', data)
      })
    },
    getRouter(context) {
      return new Promise(async resolve => {
        let type = getStore({
          name: "userType"
        })
        let privilegesList = []
        let routerList = []
        if (type === 1) {
          const res = await getUserRules()
          privilegesList = res.SellerPrivileges
          routerList = routerAll
        } else if (type === 2) {
          const res = await getAdminUserRules()
          privilegesList = res.AdminPrivileges
          routerList = adminRouterAll
        }
        if (privilegesList.length === 1 && privilegesList[0] == 0) {
          let menu = onloadMenu(routerList)
          context.commit('updateFirstRoute', true)
          context.commit('updateMenu', menu)
          resolve(routerList)
        } else {
          let list = setRouter(privilegesList, routerList)
          let menu = onloadMenu(list)
          context.commit('updateFirstRoute', true)
          context.commit('updateMenu', menu)
          resolve(list)
        }
      })
    },
    setProductType(context, data) {
      context.commit('updateProductType', data)
    },
    async setTxStatus(context) {
      try {
        const res = await getTxType()
        context.commit('updateTxStatus', res.success)
        console.log('提现接口调用失败')
      } catch {
        console.log('提现接口调用失败')
      }
    }
  }
}
const setRouter = (SellerPrivileges, data) => {
  let routerAll = _.cloneDeep(data)
  let list = routerAll.map(item => {
    if (item.children && item.children.length > 0) {
      item.children = item.children.filter(ele => {
        if (ele.children && ele.children.length > 0) {
          ele.children = ele.children.filter(ele => SellerPrivileges.findIndex(item => Number(item) ===
            Number(ele.meta.key)) > -1)
          return true
        } else {
          return SellerPrivileges.findIndex(item => Number(item) === Number(ele.meta.key) || ele.meta.user ===
            0) > -1
        }
      })
    }
    return {
      ...item
    }
  })
  return filterMenu(list)
  // return list.filter(item => {
  //     if(item.children){
  //        item.children =  item.children.filter(ele => {
  //             if(ele.children){
  //               return ele.children.length>=1
  //             }else{
  //               return true
  //             }
  //        })
  //     }
  //     return item.children&&item.children.length>=1
  // })
}
const setMenu = (data, url) => {
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    item.path = `${url}/${item.path.replace('/:id?', '')}`
    item.url = item.path
    item.title = item.name
    if (item.children && item.children.length >= 1) {
      item.children = item.children.filter(item => item.meta.isShow !== false)
      setMenu(item.children, item.path)
    }
  }
}
//加载左侧菜单
const onloadMenu = (routerAll) => {
  let routerList = _.cloneDeep(routerAll)
  let list = routerList.filter(item => item.isShow !== false)
  list.forEach(item => {
    item.url = item.path
    item.title = item.name
    item.children = item.children.filter(item => item.isShow !== false)
    setMenu(item.children, item.path)
  })

  if (getStore({
      name: "userRole"
    }) == 111111 || getStore({
      name: "userRole"
    }) == 8) {
    list.unshift({
      title: "控制台",
      url: "/user/overview",
      icon: "icon-huiyuan",
    })

  } else {
    list.unshift({
      title: "控制台",
      url: "/user/home",
      icon: "icon-huiyuan",
    })
  }
  return list
}

//过滤 有子级菜单但是没权限

const filterMenu = (data) => {
  let partnerId = getStore({
    name: "partnerId"
  })
  let userStatus = getStore({
    name: "userStatus"
  })
  return data.filter(item => {
    if (item.children) {
      item.children = filterMenu(item.children)
      if (item?.meta?.key == 7002 ) {//优惠券
        if(partnerId != 110 || userStatus != 1){
          item.meta.isShow = false
        }
      }
      return item.children.length >= 1
    } else {
      return true
    }
  })
}

export default app
